export const shapeAddGiftVoucherPayload = (args) => {
  const {
    payloadFromSC,
    inputsData: { OtherAmount, EmailAddress, ConfirmEmailAddress, Message },
    dropdownsData: { selectedAmount, selectedAmountDesc },
  } = args;

  const requestPayloadModel = {
    ...payloadFromSC,
    OtherAmount,
    EmailAddress,
    ConfirmEmailAddress,
    Message,
    SelectedAmount: selectedAmount,
    SelectedAmountDesc: selectedAmountDesc,
  };

  return requestPayloadModel;
};
